import { render } from "./App.vue?vue&type=template&id=2d601d1c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2d601d1c&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8139b95a26b815b72959245a13841758/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__